"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReadyStatus = exports.usePromise = exports.ReadyStatus = void 0;
const react_1 = require("react");
const uuid_1 = require("uuid");
var ReadyStatus;
(function (ReadyStatus) {
    ReadyStatus["DEFAULT"] = "DEFAULT";
    ReadyStatus["FETCHING"] = "FETCHING";
    ReadyStatus["SUCCESS"] = "SUCCESS";
    ReadyStatus["FAILURE"] = "FAILURE";
})(ReadyStatus = exports.ReadyStatus || (exports.ReadyStatus = {}));
const usePromise = (creator) => {
    const isMountedRef = (0, react_1.useRef)(true);
    const pendingKeyRef = (0, react_1.useRef)('');
    const [status, setStatus] = (0, react_1.useState)(ReadyStatus.DEFAULT);
    const [result, setResult] = (0, react_1.useState)();
    const [error, setError] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => () => {
        isMountedRef.current = false;
    }, []);
    const create = (parameters) => {
        const key = (0, uuid_1.v4)();
        pendingKeyRef.current = key;
        setStatus(ReadyStatus.FETCHING);
        const handleResult = (r) => {
            if (isMountedRef.current && pendingKeyRef.current === key) {
                setResult(r);
                setStatus(ReadyStatus.SUCCESS);
            }
        };
        const handleError = (e) => {
            if (isMountedRef.current && pendingKeyRef.current === key) {
                setError(e);
                setStatus(ReadyStatus.FAILURE);
            }
        };
        creator(parameters).then(handleResult).catch(handleError);
    };
    return [status, create, result, error];
};
exports.usePromise = usePromise;
const useReadyStatus = (statuses) => {
    const [status, setStatus] = (0, react_1.useState)(ReadyStatus.DEFAULT);
    const getStatus = () => {
        if (statuses.includes(ReadyStatus.FAILURE))
            return ReadyStatus.FAILURE;
        if (statuses.includes(ReadyStatus.DEFAULT))
            return ReadyStatus.DEFAULT;
        if (statuses.includes(ReadyStatus.FETCHING))
            return ReadyStatus.FETCHING;
        return ReadyStatus.SUCCESS;
    };
    (0, react_1.useEffect)(() => {
        setStatus(getStatus());
    }, statuses);
    return status;
};
exports.useReadyStatus = useReadyStatus;
